export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-carbon">
      <div className="flex flex-col items-center gap-4">
        <i className="ri-loader-4-line animate-spin text-3xl text-electric-bright" />
        <span className="text-gray-400 text-sm">Cargando…</span>
      </div>
    </div>
  );
}